import React from "react";
import { useNavigate } from "react-router-dom"; // For navigation

import AutomobilityTabs from './AutomobilityTabs';
import AerospaceIntroductioncards from './AerospaceIntroductioncards';
import AerospaceanimatedCards from './AerospaceanimatedCards';
import Carrerssection from './Carrerssection';
import ValueFirstDatasection from './ValueFirstDatasection';

const CaseStudiesSectionpage = () => {
    const navigate = useNavigate(); // React Router navigation hook all the data not foundend in the real time example and experiance in this code 

    const redirectToPage = (path) => {
        navigate(path);
    };

    return (
        <div>
            {/* Internal CSS */}
            <style>
                {`
          .container {
            margin: 0;
            padding: 0;
            width: 100%;
            height: 100%;
            box-sizing: border-box;
          }

          .navigation {
            top: 0;
            width: 100%;
            display: flex;
            justify-content: center;
            background-color: #fff;
            padding: 20px 0;
            z-index: 1000;
          }

          .navigation button {
  margin: 0 1px;
  padding: 15px 30px;
  font-size: 18px;
  background-color: #fff;
  color: #11a1b0;
  border: 2px solid #11a1b0; /* Added a 2px black border */
  border-radius: 50px;
  cursor: pointer;
  width: 300px;
  text-align: center;
  transition: background-color 0.3s ease;
}


          .navigation button:hover {
            background-color: #caf6fb;
          }

          .section {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          }
        `}
            </style>

            {/* Navigation Buttons */}
            <div className="navigation">
                <button onClick={() => redirectToPage('/casestudysuccesstory')}>Customer Success Story</button>
                <button onClick={() => redirectToPage('/digitalmanufaturingcasestudy')}>Digital Manufacturing</button>
                <button onClick={() => redirectToPage('/linedesignpage')}>Line Design</button>
                <button onClick={() => redirectToPage('/teamcenterpage')}>Team Center Manufacturing</button>
            </div>


        </div>
    );
};

export default CaseStudiesSectionpage;
